/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { Box, Button, Container, Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';

// import styles
import { useNavigate } from 'react-router-dom';
import useStyles from '../../assets/styles/components/footerMenuMain';

// import icon svg
import { ReactComponent as IconHome0 } from '../../assets/images/svg/menu_main/icon_home_0.svg';
import { ReactComponent as IconHomeActiv } from '../../assets/images/svg/menu_main/icon_home_activ.svg';
import { ReactComponent as IconRequest0 } from '../../assets/images/svg/menu_main/icon_pedidos_0.svg';
import { ReactComponent as IconRequestActiv } from '../../assets/images/svg/menu_main/icon_pedidos_active.svg';
import { ReactComponent as IconSearch } from '../../assets/images/svg/menu_main/icon_pesquisa.svg';
import { ReactComponent as IconFidelidade0 } from '../../assets/images/svg/menu_main/icon_fidelidade_0.svg';
import { ReactComponent as IconFidelidadeActive } from '../../assets/images/svg/menu_main/icon_fidelidade_active.svg';
import { getStorege } from '../../helpers/db_storage';
import { useShopContext } from '../../providers/use-shop';

const FooterMenuMain = ({ children }: any) => {
  const classeStyle = useStyles();
  const navigate = useNavigate();
  const { data } = useShopContext();

  const [requestLocalStoregeCart, setRequestLocalStoregeCart] = useState<any>();

  const handleToPage = (url: string) => {
    return navigate(url);
  };

  useEffect(() => {
    const result = getStorege('@mais/delivery/shop/request/product/cart');

    if (result) {
      setRequestLocalStoregeCart(result);
    }
  }, []);

  return (
    <Container maxWidth={false} className={classeStyle.container}>
      <Box
        sx={{
          flexGrow: 1,
          boxShadow: 1,
          bgcolor: (theme) =>
            theme.palette.mode === 'dark' ? '#101010' : '#fff',
          color: (theme) =>
            theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800',
          p: 1,
          m: 1,
          borderRadius: 2,
          textAlign: 'center',
          fontSize: '0.875rem',
          fontWeight: '700',
        }}
        className={classeStyle.box}
      >
        <Grid item xs={12}>
          {children === 'DetailShop' &&
            requestLocalStoregeCart &&
            window.atob(requestLocalStoregeCart.idRestaurante) ==
              data.shop.idRestaurante && (
              <Grid container justifyContent="center">
                <Button
                  className={classeStyle.btnSubmit}
                  onClick={() =>
                    handleToPage(
                      `/shop/request/detail/${window.btoa(
                        data.shop.idRestaurante,
                      )}`,
                    )
                  }
                  variant="contained"
                  style={{
                    width: '80%',
                    zIndex: 10,
                  }}
                >
                  Finalizar pedido
                </Button>
              </Grid>
            )}
        </Grid>
        <Grid
          textAlign="center"
          justifyContent="space-around"
          alignItems="center"
          container
        >
          <Grid>
            <Button
              style={{ padding: '6px 0px' }}
              className={children === 'Shop' ? classeStyle.houveBtn : ''}
              onClick={() => handleToPage('/')}
            >
              {children === 'Shop' ? (
                <IconHomeActiv className={classeStyle.iconPromotion} />
              ) : (
                <IconHome0 className={classeStyle.iconPromotion} />
              )}
              <p className={classeStyle.textBtn}>Início</p>
            </Button>
          </Grid>
          <Grid>
            <Button
              style={{ padding: '6px 0px' }}
              className={children === 'promotions' ? classeStyle.houveBtn : ''}
              onClick={() => handleToPage('/explore')}
            >
              <IconSearch className={classeStyle.iconPromotion} />

              <p
                className={
                  children === 'promotions'
                    ? classeStyle.textBtnBold
                    : classeStyle.textBtn
                }
              >
                Explorar
              </p>
            </Button>
          </Grid>
          <Grid>
            <Button
              style={{ padding: '6px 0px' }}
              className={children === 'fidelity' ? classeStyle.houveBtn : ''}
              onClick={() => handleToPage('/fidelity')}
            >
              {children === 'fidelity' ? (
                <IconFidelidadeActive className={classeStyle.iconPromotion} />
              ) : (
                <IconFidelidade0 className={classeStyle.iconPromotion} />
              )}

              <p
                className={
                  children === 'fidelity'
                    ? classeStyle.textBtnBold
                    : classeStyle.textBtn
                }
              >
                Fidelidade
              </p>
            </Button>
          </Grid>
          <Grid>
            <Button
              style={{ padding: '6px 0px' }}
              className={children === 'Request' ? classeStyle.houveBtn : ''}
              onClick={() => handleToPage('/dashboard/user/request')}
            >
              {children === 'Request' ? (
                <IconRequestActiv className={classeStyle.iconPromotion} />
              ) : (
                <IconRequest0 className={classeStyle.iconPromotion} />
              )}
              <p
                className={
                  children === 'Request'
                    ? classeStyle.textBtnBold
                    : classeStyle.textBtn
                }
              >
                Pedidos
              </p>
              {requestLocalStoregeCart?.pedido_cardapio?.length > 0 && (
                <p className={classeStyle.textBtnNotification}>
                  {requestLocalStoregeCart?.pedido_cardapio?.length > 0 && 1}
                </p>
              )}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};
export default FooterMenuMain;
